import { Configuration, RedirectRequest } from '@azure/msal-browser';

const authority = process.env.REACT_APP_AUTH_AUTHORITY!;
const authorityHost = new URL(authority).host;
const baseLoginScopes = ['openid', 'profile', 'email'];
const appOrigin = window.location.origin;

// Dedicated page for silent token renew to avoid hash handling by the SPA router.
// Ensure this URI is also registered in Entra as SPA redirect URI.
export const silentRedirectUri = `${appOrigin}/auth/silent-redirect.html`;

// Vul deze waarden in vanuit je Entra External ID tenant.
// Zie .env voor de omgevingsvariabelen.
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AUTH_CLIENT_ID!,
        // Formaat: https://<tenant>.ciamlogin.com/<tenant>.onmicrosoft.com
        authority,
        knownAuthorities: [authorityHost],
        redirectUri: appOrigin,
        postLogoutRedirectUri: appOrigin,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        // localStorage + cookie fallback is more resilient for redirect roundtrips across browsers.
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    },
};

// De scopes die bij login worden gevraagd (openid + profile zijn standaard)
export const loginRequest: RedirectRequest = {
    scopes: baseLoginScopes,
};

// API requests gebruiken dezelfde basis scopes; de client stuurt het ID-token naar EasyAuth.
export const apiScopes: string[] = baseLoginScopes;

